import styled from 'styled-components';
import { StyledPopover } from '../debt_list/debtList.styled';

export const StyledYearlyByMonths = styled.div`
    #section-to-print {
        position: absolute; 
        bottom: 5000px;
    }

    .report-top {
        margin: 25px 0;
    }

    .ScrollbarsCustom-Wrapper {
        margin-right: 10px;     
    }

    .ScrollbarsCustom-Scroller {
        ::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
        margin-right: 0 !important;
    }

    .column-titles {
        display: grid;
        grid-template-columns: repeat(15, 1fr);
        font-weight: 700;
        font-size: 12px;
        text-align: center;
        color: rgba(55, 54, 71, 0.7);
        gap: 15px;
        margin-bottom: 10px;
        padding-left: ${({ ltr }) => ltr ? '14px' : '10px'};
        padding-right: 34px;
        width: 95%;
        
        span {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .month-header {
            cursor: pointer;
        }
    }

    .cards-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        gap: 14px; 
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'}; 
    } 

    .scroll-container {
        background: #F9F9FF;
        border: 1px solid var(--bllink-purple);
        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 25px;
        padding: 19px 15px;                 
    }

    .total-row {
        width: 95%;
        margin-top: 23px;
        font-size: 12px;
        font-weight: 700;
        text-align: center;
        display: grid;
        grid-template-columns: repeat(15, 1fr);
        margin-inline-start: ${({ ltr }) => ltr ? '20px' : '35px'};
        padding-inline-end: 50px;

        span {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .one-time {
        border-inline-start: 1px solid #A8C0FF;
    }
`

export const StyledCardWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 20px;
`

export const StyledYearlyCard = styled.div`
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #A8C0FF;
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 11px;
    padding: 16px 14px;
    display: grid;
    grid-template-columns: repeat(15, 1fr);
    gap: 15px;
    width: 95%;
    font-size: 12px;
    color: rgba(55, 54, 71, 0.7);
    position: relative;
    text-align: center;
    height: 66px;

    .apartment {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .total-column, .one-time {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`
